import { render, staticRenderFns } from "./RestoreAlert.vue?vue&type=template&id=d3ff5342"
import script from "./RestoreAlert.vue?vue&type=script&lang=ts"
export * from "./RestoreAlert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports